<template>
	<div class="yt-sidebar">
		<div class="yt-sidebar-inner pl-3 pr-3 pt-2">
			<ul class="navbar-nav text-right">
				<!-- <li class="nav-item active">
					<router-link :to="{ name: 'Dashboard' }" class="nav-link"
						>Dashboard
						<span class="sr-only">(current)</span></router-link
					>
				</li> -->
				<li class="nav-item ">
					<router-link :to="{ name: 'Dashboard' }" class="nav-link"
						>Dashboard
						<span class="sr-only">(current)</span></router-link
					>
				</li>
				<li class="nav-item ">
					<router-link :to="{ name: 'Lessons' }" class="nav-link"
						>Lessons
						<span class="sr-only">(current)</span></router-link
					>
				</li>
				<li
					v-if="isSuperAdmin()"
					class="nav-item"
				>
					<router-link :to="{ name: 'SchoolList' }" class="nav-link"
						>Schools</router-link
					>
				</li>
				<li v-if="isSuperAdmin()" class="nav-item">
					<router-link :to="{ name: 'UserList' }" class="nav-link"
						>Admin Users</router-link
					>
				</li>
				<li class="nav-item">
					<router-link :to="{ name: 'SubjectList' }" class="nav-link"
						>Courses</router-link
					>

					<ul class="navbar-nav subnav">
						<li>
							<router-link
								:to="{ name: 'GroupList' }"
								class="nav-link"
								>Subjects</router-link
							>
						</li>
						<li>
							<router-link
								:to="{ name: 'GradeList' }"
								class="nav-link"
								>Grade Levels</router-link
							>
						</li>
					</ul>
				</li>
				<li class="nav-item">
					<router-link :to="{ name: 'StudentList' }" class="nav-link"
						>Users</router-link
					>
					<ul class="navbar-nav subnav">
						<li>
							<router-link
								:to="{ name: 'ApprovalSubjects' }"
								class="nav-link"
								>Pending Tutor Approval</router-link
							>
						</li>
					</ul>
				</li>
				<li v-if="isSuperAdmin()" class="nav-item">
					<router-link :to="{ name: 'DCList' }" class="nav-link"
						>Dynamic Content</router-link
					>
				</li>
				<li v-if="isSuperAdmin() || isAdmin()" class="nav-item">
					<router-link :to="{ name: 'ChatList' }" class="nav-link"
						>Chat Messages</router-link
					>
				</li>
				<!-- <li class="nav-item">
                    <a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">Disabled</a>
                </li> -->
			</ul>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const appModule = namespace('app')

@Component()
export default class Sidebar extends Vue {
	@appModule.State('filterBySchool') stateFilterBySchool

	@Prop({
		type: Object,
		default: () => {}
	})
	userProfile

	isSuperAdmin() {
		return this.userProfile && this.userProfile.role === 'superadmin'
	}
	isAdmin() {
		return this.userProfile && this.userProfile.role === 'administrator'
	}
}
</script>

<style lang="scss" scoped>
@import '@/_variables.scss';

.yt-sidebar {
	border-right: 1px solid $gray-400;
	height: 100%;

	.navbar-nav {
		.subnav {
			a {
				color: $gray-800;
				font-size: 11px;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/Sidebar.vue